module.exports = __webpack_public_path__ + "static/img/khk001-logo_01.342c5500.png";